import { render } from "./HuruCriminalCheckVerification.vue?vue&type=template&id=a5407c96"
import script from "./HuruCriminalCheckVerification.vue?vue&type=script&lang=js"
export * from "./HuruCriminalCheckVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__